import i18next from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from './public/locales/en/translation.json';
import translationFR from './public/locales/fr/translation.json';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    fr: {
        translation: translationFR
    }
};

i18next
    .use(detector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: {
            en: ['en'],
            fr: ['fr'],
            default: ['en']
        },
        load: 'languageOnly',
        debug: Boolean(process.env.I18_DEBUG),
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        react: {
            // https://react.i18next.com/latest/trans-component#trans-props
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
        }
    });

export default i18next;
